export const headersSynthetic: any = {
    header: [
        {
            name: 'razaoSocialAgente',
            text: 'Agente Financeiro',
            position: 0
        },
        {
            name: 'cnpjAgente',
            text: 'CNPJ Agente',
            position: 1
        },
        {
            name: 'uf',
            text: 'UF',
            position: 2
        },
        {
            name: 'tipoOperacao',
            text: 'Tipo Serviço',
            position: 3
        },
        {
            name: 'quantidade',
            text: 'Quantidade',
            position: 4,
            alignTo: 'center'
        },
        {
            name: 'valorRegistradora',
            text: 'Valor Registradora',
            position: 5
        },
        {
            name: 'totalValorRegistradora',
            text: 'Valor Total Registradora',
            position: 6
        },
        {
            name: 'taxaRegistro',
            text: 'Taxa Registro',
            position: 7
        },
        {
            name: 'totalTaxaRegistro',
            text: 'Valor Total Taxa Registro',
            position: 8
        }
    ]
}

export const keysFormatCurrency = [
    'valorRegistradora',
    'taxaRegistro',
    'totalValorRegistradora',
    'totalTaxaRegistro'
]

export const headersAnalytical: any = {
    header: [
        {
            name: 'razaoSocialAgente',
            text: 'Agente Financeiro',
            position: 1
        },
        {
            name: 'cnpjAgente',
            text: 'CNPJ Agente',
            position: 2
        },
        {
            name: 'uf',
            text: 'UF Detran',
            position: 3
        },
        {
            name: 'tipoOperacao',
            text: 'Tipo Operação',
            position: 4
        },
        {
            name: 'dataRegistro',
            text: 'Data Registro',
            position: 5
        },
        {
            name: 'valorRegistradora',
            text: 'Valor Registradora',
            position: 6
        },
        {
            name: 'taxaRegistro',
            text: 'Taxa Registro',
            position: 7
        },
        {
            name: 'numeroContrato',
            text: 'N° Contrato',
            position: 8
        },
        {
            name: 'numeroRegistro',
            text: 'N° Registro',
            position: 9
        },
        {
            name: 'renavam',
            text: 'RENAVAM',
            position: 10
        },
        {
            name: 'numeroGravame',
            text: 'N° Gravame',
            position: 11
        },
        {
            name: 'chassi',
            text: 'Chassi',
            position: 12
        },
        {
            name: 'placa',
            text: 'Placa',
            position: 13
        }
    ]
}
